import queueService from "../api/server/queueService";
import authentication from "@/authentication";
import moment from "moment";
export const QUEUE_NAMESPACE = "queueConfigModule";

var fakeService;
const loadFakeService = async () => {
  if (fakeService) return fakeService;
  return import(
    `../api/${process.env.VUE_APP_SERVICE_FOLDER}/queueService`
  ).then(x => {
    fakeService = x.default;
    return fakeService;
  });
};

var services = {
  api:
    (process.env.VUE_APP_SERVICE_FOLDER === "fakes" &&
      process.env.NODE_ENV === "development") ||
    process.env.NODE_ENV === "test"
      ? loadFakeService()
      : Promise.resolve(queueService)
};

const state = {
  carrierNames: {},
  clientNames: {},
  loadingCarriers: false,
  loadingClients: false,
  loadingHistory: false,
  loadingQueueDetailList: false,
  loadingQueueList: false,
  postponeHistory: [],
  queueDetailList: [],
  queueList: [],
  engagementTimes: [],
  loadingEngagementTimes: false,
  savingEngagementTimes: false
};

const actions = {
  async loadCarriers(context) {
    context.state.loadingCarriers = true;
    var api = await services.api;
    return api.loadCarriers().then(function(value) {
      context.state.loadingCarriers = false;
      context.commit("setCarrierNames", value);
    });
  },
  async loadClients(context) {
    context.state.loadingClients = true;
    var api = await services.api;
    return api.loadClients().then(function(value) {
      context.state.loadingClients = false;
      context.commit("setClientNames", value);
    });
  },
  async loadQueueDetails(context, workflow) {
    context.state.queueDetailList = [];
    context.state.loadingQueueDetailList = true;
    var api = await services.api;
    return api.loadQueueDetails(workflow).then(function(value) {
      context.state.loadingQueueDetailList = false;
      context.state.queueDetailList = value;
    });
  },
  async loadHistory(context, hoursBack) {
    context.state.postponeHistory = [];
    context.state.loadingHistory = true;
    var api = await services.api;
    return api.loadHistory(hoursBack).then(function(value) {
      context.state.loadingHistory = false;
      context.state.postponeHistory = value;
    });
  },
  async loadQueues(context) {
    context.state.loadingQueueList = true;
    var api = await services.api;
    return api.loadQueues().then(function(value) {
      context.state.loadingQueueList = false;
      context.state.queueList = value;
    });
  },
  async postponeQueues(context, postponeData) {
    var api = await services.api;
    var user = authentication.getUser();
    var auditData = {
      Name: user.profile.name,
      ActiveDirectoryId: user.profile.oid,
      UniqueName: user.profile.unique_name,
      Action: postponeData.ActionText,
      PartitionKey: user.profile.oid,
      RowKey: Date.now()
    };
    var data = {
      Audit: auditData,
      PostponeAll: postponeData.PostponeAll,
      PostponeItems: postponeData.PostponeItems,
      PostponeTimeInMinutes: postponeData.PostponeTime
    };
    return api.postponeQueues(data);
  },
  async loadEngagementTimes(context) {
    context.state.loadingEngagementTimes = true;
    var api = await services.api;
    return api.getEngagementTime().then(function(value) {
      context.state.loadingEngagementTimes = false;
      context.commit("setEngagementTimes", value);
    });
  },
  async saveEngagementTimes(context, payload) {
    context.state.savingEngagementTimes = true;
    var api = await services.api;
    return api.setEngagementTime(payload).then(function(value) {
      context.state.savingEngagementTimes = false;
    });
  }
};

const mutations = {
  setCarrierNames(storeState, data) {
    storeState.carrierNames = {};
    data.forEach(x => {
      storeState.carrierNames[x.Id] = x.Name;
    });
  },
  setClientNames(storeState, data) {
    storeState.clientNames = {};
    data.forEach(x => {
      storeState.clientNames[x.Id] = x.Name;
    });
  },
  setEngagementTimes(storeState, data) {
    storeState.engagementTimes = [];
    data.forEach(x => {
      x.LocalEngagementTimeTemp = moment(
        moment().format("YYYY-MM-DD") + " " + x.LocalEngagementTime
      ).format("HH:mm");
      storeState.engagementTimes.push(x);
    });
  }
};

const getters = {
  carrierNames: storeState => storeState.carrierNames,
  clientNames: storeState => storeState.clientNames,
  loadingCarriers: storeState => storeState.loadingCarriers,
  loadingClients: storeState => storeState.loadingClients,
  loadingHistory: storeState => storeState.loadingHistory,
  loadingQueueDetailList: storeState => storeState.loadingQueueDetailList,
  loadingQueueList: storeState => storeState.loadingQueueList,
  postponeHistory: storeState => storeState.postponeHistory,
  queueDetailList: storeState => storeState.queueDetailList,
  queueList: storeState => storeState.queueList,
  engagementTimes: storeState => storeState.engagementTimes,
  loadingEngagementTimes: storeState => storeState.loadingEngagementTimes,
  savingEngagementTimes: storeState => storeState.savingEngagementTimes
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  services
};
